import { render, staticRenderFns } from "./ManageEntrance.vue?vue&type=template&id=4a0f4e1a&scoped=true&"
import script from "./ManageEntrance.vue?vue&type=script&lang=ts&"
export * from "./ManageEntrance.vue?vue&type=script&lang=ts&"
import style0 from "./ManageEntrance.vue?vue&type=style&index=0&id=4a0f4e1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f4e1a",
  null
  
)

export default component.exports